'use strict';

require('array.prototype.flat/auto');
require('array.prototype.flatmap/auto');

require('symbol.prototype.description/auto');

require('string.prototype.matchall/auto');




//////////////////
// WEBPACK FOOTER
// ./node_modules/airbnb-js-shims/target/es2019.js
// module id = 317
// module chunks = 22